import { render, staticRenderFns } from "./LastAddedPositions.vue?vue&type=template&id=7f407563"
import script from "./LastAddedPositions.vue?vue&type=script&lang=js"
export * from "./LastAddedPositions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports